import { urls } from "../../shared/seo/links";

// Items from the API's internal-link endpoints (avoconsulte-be/src/seo/content.js):
// { kind: "guide" | "faq", id, title, language }.
export function contentPath(item) {
  return item.kind === "faq" ? urls.questionPath(item) : urls.blogPath(item);
}

/** Governorate objects for the city keys the API returns, unknown ones dropped. */
export function citiesOf(keys) {
  return (Array.isArray(keys) ? keys : []).map((key) => urls.findGovernorate(key)).filter(Boolean);
}

/** BreadcrumbList JSON-LD for [{ name, path }] (decoded paths). */
export function breadcrumbJsonLd(items) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((item, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: item.name,
      item: urls.absoluteUrl(window.location.origin, item.path),
    })),
  };
}
